var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99985 3.92664C7.39837 3.92664 6.85341 4.01857 6.36353 4.16553C6.09901 4.24489 5.82029 4.09481 5.74093 3.83031C5.66157 3.56581 5.81169 3.28707 6.07617 3.20772C6.65297 3.03469 7.29465 2.92664 7.99985 2.92664C11.2185 2.92664 13.8332 5.51309 13.8332 8.71329C13.8332 11.9135 11.2185 14.5 7.99985 14.5C4.78113 14.5 2.1665 11.9135 2.1665 8.71329C2.1665 7.52309 2.53182 6.41297 3.15198 5.49369C3.30642 5.26477 3.61719 5.20437 3.84611 5.35881C4.07501 5.51325 4.13541 5.82401 3.98099 6.05293C3.46782 6.81361 3.1665 7.73021 3.1665 8.71329C3.1665 11.3531 5.32521 13.5 7.99985 13.5C10.6745 13.5 12.8332 11.3531 12.8332 8.71329C12.8332 6.07353 10.6745 3.92664 7.99985 3.92664Z",
    fill: "#F26F21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43849 1.58052C7.67013 1.73079 7.73613 2.04042 7.58585 2.27209L6.73893 3.5778L8.05701 4.42624C8.28921 4.57568 8.35625 4.88508 8.20681 5.11728C8.05733 5.34948 7.74793 5.41656 7.51577 5.26708L5.77577 4.14708C5.66401 4.07516 5.58549 3.96168 5.55757 3.83174C5.52961 3.70179 5.55457 3.56608 5.62689 3.45457L6.74689 1.7279C6.89717 1.49623 7.20681 1.43024 7.43849 1.58052Z",
    fill: "#F26F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.d7cc5d20d4e2189f0872cf13da36cb21.svg";
export { ForwardRef as ReactComponent };